import { useMemo } from 'react';
import { Link } from 'react-router-dom';
import LogoBranca from '../assets/LogoBranca.png';
import BarraLogos from '../assets/barraelogos.png';
import { useAuth } from '../context/AuthContext.js';

const Footer = () => {
  const { isAuthenticated: authenticated, userRole } = useAuth();
  // UX-only — menus/links, not access control
  const admin = userRole === 'ADM';
  const monitor = userRole === 'MON';

  const role = useMemo(() => {
    if (!authenticated) return 'guest';
    if (admin) return 'admin';
    if (monitor) return 'monitor';
    return 'user';
  }, [authenticated, admin, monitor]);

  const homeRoute = useMemo(() => {
    if (role === 'admin') return '/dashboard';
    if (role === 'monitor') return '/monitor-dashboard';
    if (role === 'user') return '/cursos';
    return '/';
  }, [role]);

  return (
    <footer className='flex flex-col'>
      {/* Parceiros Section */}
      <div className='w-full bg-white py-8'>
        <div className='container mx-auto px-6 text-center max-w-[1536px]'>
          <h3 className='text-[#54737a] text-sm uppercase tracking-wider mb-6 font-medium'>
            Parceiros
          </h3>
          <img
            src={BarraLogos}
            alt='Parceiros'
            className='w-full h-auto max-h-40 object-contain mx-auto'
          />
        </div>
      </div>

      {/* Main Footer Content */}
      <div className='bg-[#002B36] text-white pt-12 pb-4'>
        <div className='container mx-auto px-6 max-w-[1536px]'>
          {/* Top part: Logo/Text and Links */}
          <div className='flex flex-col md:flex-row justify-between items-start mb-12'>
            {/* Left Side: Logo and Tagline */}
            <div className='md:max-w-md mb-8 md:mb-0'>
              <Link to={homeRoute} className='inline-block mb-4'>
                {/* Adjusting logo size to match design */}
                <img src={LogoBranca} alt='4Control' className='h-12 w-auto' />
              </Link>

              <p className='text-[#54737a] text-sm max-w-sm'>
                Conectando teoria e prática na Operação e Manutenção de reatores
                Fischer-Tropsch para a indústria de SAF.
              </p>
            </div>
            {/* Right Side: Links */}
            <div>
              <h3 className='font-bold text-white mb-4'>Páginas:</h3>
              <ul className='space-y-2'>
                <li>
                  <Link
                    to='/privacidade'
                    className='text-[#94a3b8] hover:text-white transition-colors text-sm'
                  >
                    Política de privacidade
                  </Link>
                </li>
                <li>
                  <Link
                    to='/termos'
                    className='text-[#94a3b8] hover:text-white transition-colors text-sm'
                  >
                    Termos de uso
                  </Link>
                </li>
                <li>
                  <Link
                    to='/confidencialidade'
                    className='text-[#94a3b8] hover:text-white transition-colors text-sm'
                  >
                    Termos de Confidencialidade
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          {/* Copyright Section */}
          <div className='border-t border-[#1e4e5f] pt-6 text-center'>
            <p className='text-[#54737a] text-xs'>
              © 2026 GIZ. Todos os direitos reservados.
              Desenvolvido pela 4Control, com apoio técnico da Geo bio gas&carbon
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
